<div class="container-fluid p-0 m-0">
    <app-shared type="avoir" [status]="status"></app-shared>
</div>
